import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Business from '../views/Business.vue'
import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: About },
  { path: '/business', name: 'Business', component: Business },
  { path: '/contact', name: 'Contact', component: Contact },
  // 관리자용 페이지를 routes 배열에 직접 포함시킵니다.
  {
    path: '/admin/inquiries',
    name: 'InquiryList',
    component: () => import(/* webpackChunkName: "admin" */ '../views/InquiryList.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
